export function SendOutlineIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='20' height='20' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M7.51881 10.008L16.2688 1.25796M7.62512 10.2813L9.81522 15.913C10.0082 16.4091 10.1046 16.6572 10.2436 16.7296C10.3641 16.7924 10.5077 16.7925 10.6282 16.7298C10.7673 16.6576 10.8641 16.4096 11.0576 15.9137L16.5496 1.84062C16.7242 1.39297 16.8116 1.16915 16.7638 1.02612C16.7223 0.901915 16.6248 0.804442 16.5006 0.762948C16.3576 0.715169 16.1338 0.802515 15.6861 0.977207L1.61302 6.46916C1.11713 6.66268 0.869178 6.75944 0.79692 6.89852C0.73428 7.0191 0.734365 7.16264 0.797146 7.28314C0.869568 7.42214 1.11763 7.51861 1.61375 7.71154L7.24542 9.90164C7.34613 9.9408 7.39648 9.96038 7.43888 9.99063C7.47646 10.0174 7.50933 10.0503 7.53613 10.0879C7.56638 10.1303 7.58596 10.1806 7.62512 10.2813Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
